import { createApp } from 'vue';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/all';

import { store } from './store';
import i18n from './translation';
import { initInterceptors } from './helpers/interceptor';

import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/scss/main.scss';

gsap.registerPlugin(ScrollToPlugin);

let router;
const appLoader = async () => {
  switch(process.env.VUE_APP_MOD) {
    case 'admin':
      router = (await import('./AppAdmin/router')).default;
      return (await import('./AppAdmin')).default;

    case 'app':
    default:
      router = (await import('./App/router')).default;
      return (await import('./App')).default;
  }
};

const render = async () => {
  const App = await appLoader();
  const app = createApp(App);

  app.use(store);
  app.use(router);
  app.use(i18n);
  app.mount('#app');

  initInterceptors();
};

render();
